export default __webpack_public_path__ + "static/SRF 0100S - Fiche de spécifications et données techniques-5db6759e04f1be4e802f629f2e900c9a.pdf";